<div class="relative z-10 flex h-full w-full max-w-full min-w-0 flex-col overflow-hidden bg-white shadow-2xl">
  <div class="flex shrink-0 items-start justify-between gap-2 border-b border-gray-100 px-4 py-3">
    <div class="min-w-0 flex-1">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        {{ 'board_v3_board_settings' | translate }}
      </div>
      <div class="text-base font-bold text-gray-900">{{ 'board_v3_quick_create_title' | translate }}</div>
      <div class="mt-0.5 text-xs text-gray-500">
        {{ 'board_v3_quick_create_hint' | translate }}
      </div>
    </div>
  </div>

  <div class="crm-scroll min-h-0 flex-1 overflow-x-hidden overflow-y-auto px-4 py-3 w-full">
    <div class="mb-1.5 text-[10px] font-semibold uppercase tracking-wider text-gray-400">
      {{ 'board_v3_preview' | translate }}
    </div>
    <div class="w-full overflow-hidden rounded-xl bg-gradient-to-b from-gray-100 to-gray-50 p-3 ring-1 ring-gray-100">
      <app-board-v3-quick-create-card
        [compact]="true"
        [column]="previewColumn"
        [managers]="managers"
        [createFields]="previewKeys"
        [fieldDefs]="fields"
      />
    </div>

    <div class="mt-4 flex items-center justify-between">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        {{ 'board_v3_fields' | translate }}
      </div>
      <div class="text-xs text-gray-400">{{ enabledCount }}/{{ totalCount }}</div>
    </div>

    <div class="mt-2 flex flex-col gap-1.5">
      <div class="flex w-full min-w-0 items-center gap-2 rounded-lg bg-white px-3 py-2 ring-1 ring-gray-100">
        <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none shrink-0 text-gray-500">group</app-icon>
        <span class="min-w-0 flex-1 truncate text-sm text-gray-800">{{ 'board_v3_quick_create_clients' | translate }}</span>
        <p-toggleswitch
          class="shrink-0"
          [ngModel]="isEnabled(clientsKey)"
          (ngModelChange)="setEnabled(clientsKey, $event)"
        />
      </div>
      @for (field of fields; track field.identifier) {
        <div class="flex w-full min-w-0 items-center gap-2 rounded-lg bg-white px-3 py-2 ring-1 ring-gray-100">
          <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none shrink-0 text-gray-500">{{ field.icon || 'tune' }}</app-icon>
          <span class="min-w-0 flex-1 truncate text-sm text-gray-800">{{ field.is_system ? (field.name | translate) : field.name }}</span>
          <p-toggleswitch
            class="shrink-0"
            [ngModel]="isEnabled(field.identifier)"
            (ngModelChange)="setEnabled(field.identifier, $event)"
            [disabled]="!!field.is_readonly"
          />
        </div>
      }
    </div>
  </div>

  <div class="flex justify-center gap-2 border-t border-gray-100 py-3 w-full">
    <app-button [btnType]="'cancel'" (onChangeClick)="onCancelClick()">
      {{ 'cancel' | translate }}
    </app-button>
    <app-button (onChangeClick)="onApplyClick()">
      {{ 'apply' | translate }}
    </app-button>
  </div>
</div>
